
import React from 'react';

const LeadModal = ({ formState }) => {
  const {
    isOpenForm,
    closeForm,
    name,
    setName,
    phoneMask,
    submitting,
    status,
    handleSubmit,
    HIDDEN_SOURCE,
    HIDDEN_THEME,
    t,
  } = formState;

  if (!isOpenForm) return null;

  return (
    <div className="modal-wrapper" role="dialog" aria-modal="true" onClick={closeForm}>
      <div className="modal-overlay" onClick={closeForm} />
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{t("modal.title")}</h3>
          <button className="modal-close" onClick={closeForm} aria-label={t("aria.close_modal")}>✕</button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit} noValidate>
          <div className="form-row">
            <label htmlFor="cb-name">{t("modal.label_name")}</label>
            <input
              id="cb-name"
              name="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t("modal.placeholder_name")}
              required
            />
          </div>

          <div className="form-row">
            <label htmlFor="cb-phone">{t("modal.label_phone")}</label>
            <input
              ref={phoneMask.inputRef}
              id="cb-phone"
              name="phone"
              type="tel"
              placeholder="+380XXXXXXXXX"
              value={phoneMask.phone}
              onChange={phoneMask.handlers.onChange}
              onFocus={phoneMask.handlers.onFocus}
              onBlur={phoneMask.handlers.onBlur}
              onKeyDown={phoneMask.handlers.onKeyDown}
              inputMode="tel"
              aria-invalid={!!phoneMask.phoneError}
            />
            {phoneMask.phoneError && (
              <div className="form-error" style={{ marginTop: 6 }}>
                {phoneMask.phoneError}
              </div>
            )}
          </div>

          <input type="hidden" name="source" value={HIDDEN_SOURCE} />
          <input type="hidden" name="theme" value={HIDDEN_THEME} />

          <div className="form-actions">
            <button type="button" className="btn" onClick={closeForm} disabled={submitting}>
              {t("modal.btn_cancel")}
            </button>
            <button type="submit" className="btn button" disabled={submitting}>
              {submitting ? t("modal.btn_submitting") : t("modal.btn_submit")}
            </button>
          </div>

          {status && (
            <div
              className={`form-status ${status.kind === "success" ? "success" : ""}`}
              role="status"
            >
              {status.message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LeadModal;